import { useMemo } from "react";
import type { SortingState } from "@salestrak/ui";
import { useDashboardScope } from "#app/widgets/dashboards/scope/dashboard-scope-context";
import { useTeamMembers, type TeamMember } from "#app/lib/hooks/use-team-members";

const ROSTER_SORTING: SortingState = [{ id: "name", desc: false }];

export function useTeamMembersCard(leadsFirst: boolean): {
  isTeamScope: boolean;
  members: TeamMember[];
  loading: boolean;
} {
  const scope = useDashboardScope();
  const teamId = scope?.entity?.type === "team" ? scope.entity.id : null;
  const { teamMembers, loading } = useTeamMembers(teamId ?? "", ROSTER_SORTING, {
    skip: !teamId,
  });

  const members = useMemo(() => {
    if (!leadsFirst) return teamMembers;
    return [...teamMembers].sort((a, b) => {
      if (a.role === b.role) return 0;
      return a.role === "lead" ? -1 : 1;
    });
  }, [leadsFirst, teamMembers]);

  return { isTeamScope: teamId != null, members, loading };
}
